import React, { useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Textarea,
} from '@chakra-ui/react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { cans } from '../icblast.js';

function RegistrationModal({ onClose, onRegistered }) {
  return (
    <>
      <Modal isOpen={true} onClose={onClose}>
        <ModalOverlay />
        <Formik
          initialValues={{ username: '', email: '', about: '' }}
          onSubmit={async (values, actions) => {
            let { username, email, about } = values;
            let id = await cans.qgig.user_register(username, email, about);
            onRegistered();
            console.log(values);
            actions.setSubmitting(false);
          }}
        >
          {({ isSubmitting }) => (
            <Form>
              <ModalContent>
                <ModalHeader>Register User</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <FormControl id="username" mb={4}>
                    <FormLabel>Username</FormLabel>
                    <Field as={Input} name="username" placeholder="Username" />
                    <ErrorMessage name="username" />
                  </FormControl>

                  <FormControl id="email" mb={4}>
                    <FormLabel>Email</FormLabel>
                    <Field
                      as={Input}
                      name="email"
                      placeholder="Email"
                      type="email"
                    />
                    <ErrorMessage name="email" />
                  </FormControl>

                  <FormControl id="about">
                    <FormLabel>About</FormLabel>
                    <Field
                      as={Textarea}
                      name="about"
                      placeholder="Tell us about yourself"
                    />
                    <ErrorMessage name="about" />
                  </FormControl>
                </ModalBody>

                <ModalFooter>
                  <Button
                    colorScheme="blue"
                    mr={3}
                    type="submit"
                    isLoading={isSubmitting}
                  >
                    Register
                  </Button>
                </ModalFooter>
              </ModalContent>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}

export default RegistrationModal;
